import styled from 'styled-components';
import { Container } from 'styles';
import { Text } from '@perch-labs/shrike';

export const VerticalBar = styled.div`
  flex-grow: 1;
  border-left: ${props =>
    `1px solid ${props.theme.colors.background.tertiary}`};
  border-right: ${props =>
    `1px solid ${props.theme.colors.background.tertiary}`};
  width: 0;
`;

export const Header = styled(Text).attrs({
  margin: '16px 0 8px',
  tag: 'h3',
  textStyle: 'heading500',
})``;

export const StepNumberBox = styled(Container).attrs({
  alignItems: 'center',
  flex: true,
  justifyContent: 'center',
  margin: '8px 0',
})`
  border-radius: ${props => props.theme.borderRadii.large};
  background: ${props => props.theme.colors.background.secondary};
  width: 32px;
  height: 32px;
`;

export const StepNumber = styled(Text).attrs({
  textStyle: 'heading300',
})``;

export const StepContainer = styled(Container).attrs({
  alignItems: 'center',
  direction: 'column',
  flex: true,
  flexGrow: 0,
})``;

export const ContentContainer = styled(Container).attrs({
  direction: 'column',
  flex: true,
  margin: { bottom: '24px', left: '16px' },
})`
  overflow: auto;
`;
